// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.highlighted[data-v-141cef95]{\n  position:relative\n}\n.highlighted[data-v-141cef95]:before{\n  position:absolute;\n  z-index:-1;\n  top:50%;\n  right:-4px;\n  bottom:0;\n  left:-4px;\n  content:\"\";\n  background:#fcff8a\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
